import { CaptionsItem } from '../items/captions/captions-item-type';
import { EditorStarterItem } from '../items/item-type';

export const isItemAtFrame = (
  item: EditorStarterItem,
  frame: number,
): boolean => {
  const itemStart = item.from;
  const itemEnd = item.from + item.durationInFrames;
  return frame >= itemStart && frame < itemEnd;
};

export const getCaptionItemAtFrame = ({
  items,
  targetIds,
  currentFrame,
}: {
  items: Record<string, EditorStarterItem>;
  targetIds: string[];
  currentFrame: number;
}): CaptionsItem | null => {
  for (const itemId of targetIds) {
    const item = items[itemId];
    if (!item) continue;
    if (item.type !== 'captions') continue;

    if (isItemAtFrame(item, currentFrame)) {
      return item as CaptionsItem;
    }
  }

  return null;
};

export const getCaptionItemsAtFrame = ({
  items,
  targetIds,
  currentFrame,
}: {
  items: Record<string, EditorStarterItem>;
  targetIds: string[];
  currentFrame: number;
}): CaptionsItem[] => {
  const result: CaptionsItem[] = [];

  for (const itemId of targetIds) {
    const item = items[itemId];
    if (!item) continue;
    if (item.type !== 'captions') continue;

    if (isItemAtFrame(item, currentFrame)) {
      result.push(item as CaptionsItem);
    }
  }

  return result;
};
